import { useEffect, useState } from "react"

export function useIsMobile(breakpoint: number = 768) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Prevents running during SSR
    if (typeof window === "undefined") return

    const checkScreen = () => setIsMobile(window.innerWidth <= breakpoint)

    checkScreen()
    window.addEventListener("resize", checkScreen)
    return () => window.removeEventListener("resize", checkScreen)
  }, [breakpoint])

  return isMobile
}
